export default __webpack_public_path__ + "static/media/home_pc_stats.2c6e89c9.svg";